module.exports = __webpack_public_path__ + "static/aws-1d462154e1e44fe327583a023e52b1e4.png";